import React from 'react';
import { FeedbackQuestion } from '../../../types/feedback';

interface TextareaQuestionProps {
  question: FeedbackQuestion;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const TextareaQuestion: React.FC<TextareaQuestionProps> = ({
  question,
  value,
  onChange,
  error
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className="question-container">
      <label className="question-label">
        {question.question}
        {/* Removed required asterisk - all fields are now optional */}
      </label>
      
      <textarea
        value={value}
        onChange={handleChange}
        placeholder={question.placeholder}
        className={`question-textarea ${error ? 'error' : ''}`}
        minLength={question.validation?.minLength}
        maxLength={question.validation?.maxLength}
        rows={4}
      />
      
      {question.validation?.maxLength && (
        <div className="character-count">
          {value.length}/{question.validation.maxLength}
        </div>
      )}
      
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default TextareaQuestion;
